<template>
    <v-container class="pa-0">             
        <v-row class="ma-0" justify="center" v-if="otherData">
            <v-col lg="3" md="3" sm="6" class="pa-0">
                <v-list dense two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="info">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Costo - Durata (Mobili)</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.cost_mobile | currency(5) }} &nbsp; - &nbsp; {{ otherData.total_duration_mobile_minute | duration }} h</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col lg="3" md="3" sm="6" class="pa-0">
                <v-list dense two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="indigo">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Costo - Durata (Fissi)</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.cost_national | currency(5) }} &nbsp; - &nbsp; {{ otherData.total_duration_national_minute | duration }} h</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col lg="3" md="3" sm="6" class="pa-0">
                <v-list dense two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="teal">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Costo - Durata (Esteri)</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.cost_foreign | currency(5) }} &nbsp; -  &nbsp;{{ otherData.total_duration_foreign_minute | duration }} h</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col lg="3" md="3" sm="6" class="pa-0">
                <v-list dense two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="warning">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Costo - Durata (NNG)</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.cost_nng | currency(5) }} &nbsp; - &nbsp; {{ otherData.total_duration_nng_minute | duration }} h</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
        </v-row>
        <v-row justify="center" v-if="otherData">
            <v-col lg="3" md="3" sm="6" class="pa-0">
                <v-list dense two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Durata Totale</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.total_duration_minute | duration }} h</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                
            <v-col lg="3" md="3" sm="6" class="pa-0">
                <v-list dense two-line class="background-2 w100p">
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon color="primary">mdi-currency-eur</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Costo Totale</v-list-item-title>
                            <v-list-item-subtitle>{{ otherData.total_cost | currency(5) }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>       
            </v-col>                             
        </v-row>
    </v-container>
</template>

<script>

export default {
	name: 'clis-footer',
	props: {
		items: Array,
		fieldsset: Array,
		otherData: Object,
	},

	data() {
		return {

		}
	},

	computed: {
		credit() {
			return this.otherData.credit 
		},

		debit() {
			return this.otherData.debit 
		},

		unsolved() {
			return this.otherData.unsolved 
		},
            
		total() {
			return this.otherData.credit + this.otherData.debit  + this.otherData.unsolved
		}
	},
}
</script>

<style>

</style>
